import React from 'react'
import './Style.css'
import { VariableUser } from './VariableUser'
import { AbstructVar } from '../../components/general/general-component/abstruct-component/AbstructVar'
import { filterUser } from '../../store/Actions/ActionUser'

function FilterUser({ translate }) {
    const {dispatch,langLocal} = AbstructVar()
    const { state, setStateCustom, setLoad } = VariableUser()
    const Filter = (e) =>{
        e.preventDefault()
        dispatch(filterUser(state.name,state.email,state.role,setLoad))
    }
    return (
        <div className='filteruser shadow_main margin_main' dir={langLocal=== 'ar' ? "rtl" : "ltr"}>
            <h3>{translate('search_filter')}</h3>
            <div className='div_filter' >
                <input className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('name')} onChange={(e) => setStateCustom('name', e.target.value)} />
                <input className={`input_filter ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} placeholder={translate('email')} onChange={(e) => setStateCustom('email', e.target.value)} />
                <select className={`select_filter  ${langLocal === 'ar'? "margin_left_25": "margin_right_25"} `} onChange={(e) => setStateCustom('role', e.target.value)} >
                    <option disabled="disabled" selected="selected">{translate('role')}</option>
                    <option value='manager' >manager</option>
                    <option value='reader' >reader</option>
                </select>
                <button className='btn_filter' onClick={Filter} >
                    {
                        state.Load ? "Loading ..." : `${translate('filter')}`
                    }
                </button>
            </div>
        </div>
    )
}

export default FilterUser